module.exports = __webpack_public_path__ + "static/img/project03.164eba3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/project03.png
// module id = N7O5
// module chunks = 1